import { useLang } from '@/i18n';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoSectionCarousel from 'eco-design/sections/eco-section-carousel';
import { useEffect, useState } from 'react';
import { Swiper } from 'swiper/types';
import styles from './index.module.scss';

export default function Section1Card() {
    const { t } = useLang('dp3.landing.section1Card');
    const [swiperDom, setSwiperDom] = useState<Swiper>();

    const cardList = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300787918/Frame%201612690462.jpg',
            icon: '',
            title: '',
            desc: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300787300/Frame%201000009508.jpg',
            icon: '',
            title: '',
            desc: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300788254/Frame%201612690461.jpg',
            icon: '',
            title: '',
            desc: '',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1764300787545/Frame%201612690464.jpg',
            icon: '',
            title: '',
            desc: '',
        },
    ];

    // 是否进入视图;
    const enterViewChange = () => {
        const elem = document.querySelector('#section1Card');
        if (elem) {
            const ob1 = new IntersectionObserver((elems) => {
                const elem = elems[0];
                if (elem.isIntersecting) {
                    swiperDom && swiperDom?.slideTo(0, 100, false);
                }
            });
            ob1.observe(elem);
        }
    };

    useEffect(() => {
        enterViewChange();
    }, [swiperDom]);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const secne = AniContainer.create({
                triggerElement: '#FAQ',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                secne.destroy();
            };
        }
    }, []);
    return (
        <div
            className={`page-section1Card ${styles.Section1Card} GtmModuleData-section`}
            id="section1Card"
            data-section-id={'dp3-Section1Card'}
            data-section-title={t('title')}
        >
            <EcoSectionCommon title={t('title')} />
            <div className="content">
                <div className="pc-swiper">
                    <EcoSectionCarousel
                        autoplay={{
                            delay: 3000,
                            stopOnLastSlide: false,
                            disableOnInteraction: false,
                        }}
                        scrollbar={{
                            hide: false,
                            draggable: true,
                            dragSize: 32,
                            snapOnRelease: true,
                        }}
                        swiperAutoPlay={true}
                        items={cardList}
                        pagination
                        getSwiperDom={(data: any) => setSwiperDom(data)}
                    />
                </div>
                <div className="h5-content">
                    {cardList.map((card, index) => (
                        <div className="card-item" key={index}>
                            <div className="card-image">
                                {load && <img src={card.pc} />}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
